import { wave } from './config';

export async function postGoogleWallet(card) {
  const body = {
    cardNumber: card,
  };

  const response = await wave.post('/v3/users/mobile-passes/google-wallet', body);
  return { googleJwt: response?.data?.googleJwt };
}

export async function postAppleWallet(card) {
  const body = {
    cardNumber: card,
  };
  const responseType = 'arraybuffer';
  const response = await wave.post('/v3/users/mobile-passes/apple-wallet', body, { responseType });
  return {
    data: response?.data,
    type: 'application/vnd.apple.pkpass',
  };
}
